import { styled } from 'styled-components';
import { parseTextToJSX } from '~/pages/components/game/activities-forms/utils';
import { SDivAutor, SDivParsedItem } from '~/pages/components/styles/styles';
import { renderFullPath } from '~/utils/common/utils';

type IProps = {
  text: string;
  onClick?: () => void;
  disabled?: boolean;
  autor?: string;
  autorImgSrc?: string;
};

type TProps = IProps;

export function DialogItem({ text, disabled, autor, autorImgSrc }: TProps) {
  return (
    <Container disabled={disabled}>
      <SDivParsedItem $textAling="left">{parseTextToJSX(text)}</SDivParsedItem>
      {autor && <SDivAutor>{autor}</SDivAutor>}
      {autorImgSrc && <SAutorImg src={renderFullPath(autorImgSrc)} alt="" />}
    </Container>
  );
}

const SAutorImg = styled.img`
  top: 0;
  left: 0;
  object-fit: contain;
  height: 100%;
  width: auto;
  position: absolute;
  transform: translateY(-100%);
`;

const Container = styled.div<{ disabled?: boolean }>`
  align-items: center;
  background-color: #ccecf3;
  box-shadow: inset 0 3px #009fc3;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 150px;
  padding: calc(0.7rem + 10px) 14px;
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  position: relative;
  bottom: 0;
  left: 0;
  user-select: none;
  width: 100%;

  @media screen and (max-height: 415px) {
    padding: calc(0.5rem + 6px) 5px 10px 5px;
  }
  @media screen and (min-height: 800px) {
    padding: calc(0.7rem + 10px) 24px;
  }

  @media screen and (max-width: 415px) {
    min-height: 100px;
  }
  @media screen and (max-width: 415px) {
    min-height: 130px;
  }
  @media screen and (max-height: 600px) {
    min-height: 100px;
  }
`;
